export const getOrderProductsData = (data: { [key: string]: number }, productToDelete?: string) => {
  const result = Object.entries(data).map(([id, quantity]) => ({ id, quantity }));
  if (productToDelete) {
    return result.filter((el) => el.id !== productToDelete);
  }
  return result;
};
